import { useEffect } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import { ITransferListItem, PlatformModules } from "@miplatform/types";
import { TransferList } from "@mibuildweb/components";
import { useDepartment } from "@mibuildweb/hooks";
import { ConfigAccordionHeader } from "../../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { IRoleFormData } from "../../ConfigRoles.types";

export const RoleModulesTabView = ({
  form,
}: {
  form: UseFormReturn<IRoleFormData>;
}) => {
  const departmentId = form.getValues("departmentId");
  const { department, getDepartment } = useDepartment();
  const selectedModules = useWatch({
    control: form.control,
    name: "modules",
  });
  const permissionNames = useWatch({
    control: form.control,
    name: "permissionNames",
  });

  const allModules = getModuleOptions(department?.modules || []);

  const removeModule = (moduleKey: string) => {
    const moduleValues = selectedModules.filter((m) => m !== moduleKey);
    form.setValue("modules", moduleValues, {
      shouldDirty: true,
      shouldValidate: true,
    });

    const filteredPermissions = permissionNames.filter(
      (permissionName) => !permissionName.includes(moduleKey)
    );
    form.setValue("modules", moduleValues, {
      shouldDirty: true,
      shouldValidate: true,
    });
    form.setValue("permissionNames", filteredPermissions, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  const addModule = (moduleKey: string) => {
    const moduleValues = [...selectedModules, moduleKey];
    form.setValue("modules", moduleValues as PlatformModules[], {
      shouldDirty: true,
    });
  };

  useEffect(() => {
    if (departmentId) {
      getDepartment(departmentId);
    }
  }, [departmentId]);

  return (
    <ConfigAccordionHeader title="Modules">
      <TransferList
        availableTitle="Available Modules"
        selectedTitle="Selected Modules"
        availableItems={allModules}
        selectedItems={getModuleOptions(selectedModules)}
        onAddItem={addModule}
        onRemoveItem={removeModule}
      />
    </ConfigAccordionHeader>
  );
};

const getModuleOptions = (modules: string[]) => {
  const moduleOptions: ITransferListItem[] = modules
    .map((module) => ({
      title: module,
      key: module,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));

  return moduleOptions;
};
